import React, { useState, useEffect } from "react";
// import imgs
import bg from '../../assets/End.png'


export default function Index() {

	return (
		<div>
			<div>
				<img src={bg} alt="" srcset="" />
			</div>
		</div>
	);
}
